export const RAC_TABLE_APPROVAL_CHAINS = "rac-table-approval-chains";
export const RAC_TABLE_INVOICE_TYPES = "rac-table-invoice-types";
export const RAC_TABLE_INVOICE_TYPES_COST_CENTER =
  "rac-table-invoice-types-cost-center";
export const RAC_LIST_INVOICE_TYPES = "rac-list-invoice-types";
export const RAC_INVOICE_TYPE_CONFIG_APPROVAL_CHAIN =
  "RAC_INVOICE_TYPE_CONFIG_APPROVAL_CHAIN";
